<script>
	export let opcoes;
</script>

<div class="columns">
	<div class="column is-12">
		{#each opcoes as opcao}
			<p class="control mb-2">
				<button 
					on:click|preventDefault={opcao.callback()} 
					class="button is-fullwidth {opcao.cor == null ? "is-primary" : opcao.cor}">
					{opcao.titulo}
				</button>
			</p>
		{:else}
			<p>Carregando...</p>
		{/each}
	</div>
</div>